"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SocialButton = require("./SocialButton");
Object.keys(_SocialButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SocialButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SocialButton[key];
    }
  });
});